module.exports = function ($q, settingsService, breakpointsService) {

    function SettingsByBreakpointsService() {

    }

    SettingsByBreakpointsService.prototype.getSettingValueByBreakpoint = function (group, settingNames) {
        return $q.all({
            largeFormatSettingValue: settingsService.getSettingValue(group, settingNames.largeFormat),
            mediumFormatSettingValue: settingsService.getSettingValue(group, settingNames.mediumFormat),
            smallFormatSettingValue: settingsService.getSettingValue(group, settingNames.smallFormat)
        }).then(function (result) {
            if (breakpointsService.isInLargeFormat) {
                return result.largeFormatSettingValue;
            }

            if (breakpointsService.isInMediumFormat) {
                return result.mediumFormatSettingValue;
            }

            if (breakpointsService.isInSmallFormat) {
                return result.smallFormatSettingValue;
            }

            return undefined;
        });
    };

    return new SettingsByBreakpointsService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/settings/settings-by-breakpoint-service.js
 **/